import { Ref, forwardRef, useEffect, useRef } from 'react';
import { useIntl } from 'react-intl';
import { InputField } from '@ets/design-system';

import { Textarea, type TextareaAPI, type TextareaProps } from '_common/lib/components';

type DescriptionFieldProps = {
  testId: string;
} & Pick<TextareaProps, 'initialContent' | 'mentions' | 'id' | 'onChange'>;

const DescriptionField = forwardRef(
  ({ testId, ...textareaProps }: DescriptionFieldProps, ref: Ref<TextareaAPI>) => {
    const intl = useIntl();
    const textareaRef = useRef<TextareaAPI | null>(null);

    useEffect(() => {
      setTimeout(() => {
        if (textareaRef.current) {
          textareaRef.current.focus();
        }
      }, 0);
    }, []);

    return (
      <InputField
        size="m"
        label={intl.formatMessage({ id: 'TASK_DESCRIPTION' })}
        extra={intl.formatMessage({ id: 'REQUIRED' })}
        renderFeedbackIfEmpty={false}
        testId={`${testId}-description`}
      >
        <Textarea
          size="m"
          name="description"
          type="json"
          placeholder={intl.formatMessage({
            id: 'INSERT_TASK_DESCRIPTION',
          })}
          ref={(el) => {
            textareaRef.current = el;
            if (typeof ref === 'function') ref(el);
          }}
          testId={`${testId}-description-rich-text-editor`}
          shouldFocus
          noMentionsLabel={intl.formatMessage({ id: 'NO_USERS_AVAILABLE' })}
          {...textareaProps}
        />
      </InputField>
    );
  },
);

export default DescriptionField;
